import NBType from '@netbase/nb-type'
import ChannelPostIdentifierSchema from './ChannelPostIdentifierSchema'

/**
 * @typedef {import('./ChannelPostIdentifierSchema').ChannelPostIdentifier} ChannelPostIdentifier
 */

/**
 * @typedef {object} PostsSectionSchema
 * @property {ChannelPostIdentifier[]} facebookPaidPostIdentifiers
 */
const PostsSectionSchema = NBType.object().shape('PostsSectionSchema', {
  /* @prop */
  facebookPaidPostIdentifiers: NBType.array().of(ChannelPostIdentifierSchema)
  /* END */
})
export default PostsSectionSchema
// RESERVE BELOW
